import { abilitiesPlugin } from '@casl/vue'
import Vue from 'vue'
import ability from './ability'
import { canACL } from './checkaccess'

Vue.use(abilitiesPlugin, ability)
Vue.prototype.$canACL = canACL
